import React from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import Master from "./Master";
import StudentAdmissionForm from "./tabs/StudentAdmissionForm";

export default function StudentAdmissionFormPrint() {
  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <Header />
        <div className="layout-page">
          <Nav />
          <div className="content-wrapper">
            <div className="container-fluid flex-grow-1 container-p-y">
              <div className="row">
                <Master />
                <div className="col-auto">
                  <StudentAdmissionForm />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
